import {
  BoltIcon,
  ChatBubbleLeftRightIcon,
  ClipboardDocumentIcon,
  LinkIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CheckIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import SecondaryButton from "./SecondaryButton";
import PrimaryButton from "./PrimaryButton";
import { useRecoilValue } from "recoil";
import { billingAtom } from "../store/billingAtom";
import useFetchPlans from "../hooks/useFetchPlans";
import GlobalLoadingSpinner from "./GlobalSpinner";

const DashboardFooterCards = () => {
  const [copySuccess, setCopySuccess] = useState(false);

  const [showCards, setShowCards] = useState({
    support: true,
    upgrade: true,
    refer: false,
  });

  const close = name => {
    setShowCards(prev => ({ ...prev, [name]: false }));
  };

  const referValue = "uui.com/4060020";

  const handleCopy = () => {
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 3000);
  };

  const billingInfo = useRecoilValue(billingAtom);
  const active_plan = billingInfo?.active_plan?.payment_plan
  const next_plan = billingInfo?.next_plan?.payment_plan

  const nextPlanName =
    next_plan?.name || active_plan?.name || "N/A";

  if (!showCards.support && !showCards.upgrade && !showCards.refer) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
      {showCards.support && (
        <div className="border rounded-2xl p-4 flex flex-col gap-4">
          <div className="flex items-center gap-6 justify-between">
            <span className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
              <svg
                viewBox="0 0 6 6"
                aria-hidden="true"
                className="size-1.5 fill-green-500"
              >
                <circle r={3} cx={3} cy={3} />
              </svg>
              Online
            </span>

            <button type="button" onClick={() => close("support")}>
              <XMarkIcon className="size-5 text-gray-500" />
            </button>
          </div>

          <div className="flex -space-x-1 overflow-hidden">
            <img
              alt=""
              src="https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              className="inline-block size-6 rounded-full ring-2 ring-white"
            />
            <img
              alt=""
              src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              className="inline-block size-6 rounded-full ring-2 ring-white"
            />
            <img
              alt=""
              src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80"
              className="inline-block size-6 rounded-full ring-2 ring-white"
            />
            <img
              alt=""
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              className="inline-block size-6 rounded-full ring-2 ring-white"
            />
          </div>

          <div className="flex-1">
            <p className="font-semibold p-0 m-0 mb-2">
              Need help with something?
            </p>
            <p className="p-0 m-0 text-gray-600">
              Our expert team is ready to help.
            </p>
          </div>

          <Link target="_blank" to="mailto:help@supportmagic.ai">
            <SecondaryButton
              type="button"
              startIcon={
                <ChatBubbleLeftRightIcon className="size-5 text-gray-600" />
              }
            >
              Chat with support
            </SecondaryButton>
          </Link>
        </div>
      )}

      {/* {showCards.upgrade && (
        <div className="border rounded-2xl p-4 flex flex-col gap-4 relative overflow-hidden">
          {nextPlanName === "N/A" && <GlobalLoadingSpinner />}
          <div className="flex items-center gap-6 justify-between">
            <div className="p-2 rounded-md border border-gray-300">
              <BoltIcon className="size-5 text-gray-500" />
            </div>
            <button type="button" onClick={() => close("upgrade")}>
              <XMarkIcon className="size-5 text-gray-500" />
            </button>
          </div>

          <div className="flex-1">
            <p className="font-semibold p-0 m-0 mb-2">
              Upgrade to {nextPlanName}
            </p>
            <p className="p-0 m-0 text-gray-600">
              Unlock more messages and actions
            </p>
          </div>

          <Link to="/settings/plans">
            <PrimaryButton type="button">Upgrade now</PrimaryButton>
          </Link>
        </div>
      )} */}

      {showCards.refer && (
        <div className="border rounded-2xl p-4 flex flex-col gap-4">
          <div className="flex items-center gap-6 justify-between">
            <div className="p-2 rounded-md border border-gray-300">
              <LinkIcon className="size-5 text-gray-500" />
            </div>
            <button type="button" onClick={() => close("refer")}>
              <XMarkIcon className="size-5 text-gray-500" />
            </button>
          </div>

          <div className="flex-1">
            <p className="font-semibold p-0 m-0 mb-2">Refer a friend</p>
            <p className="p-0 m-0 text-gray-600">
              Get 50% off for 12 months when someone subscribers with your link.
            </p>
          </div>

          <div className="flex items-center gap-2">
            <input
              defaultValue={referValue}
              disabled
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />

            <CopyToClipboard text={referValue} onCopy={handleCopy}>
              <button type="button">
                {copySuccess ? (
                  <CheckIcon className="size-6 text-green-600" />
                ) : (
                  <ClipboardDocumentIcon className="size-6 text-gray-600 hover:text-gray-900" />
                )}
              </button>
            </CopyToClipboard>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardFooterCards;
